import React from 'react';
import { StarIcon, QuoteIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Antes perdía casi dos semanas de cada mes persiguiendo clientes por WhatsApp. Con el Sistema PRO armé mi protocolo en una tarde y el primer mes ya noté la diferencia. Mis clientes empezaron a mandar todo sin que yo insistiera.',
    author: 'C. R.',
    age: '34 años',
    role: 'Contadora, estudio propio',
    location: 'CABA'
  }, {
    quote: 'El Tomo del Muro de Excusas solo ya vale lo que pagué. Tenía un cliente que siempre tenía una excusa diferente. Usé el script de cliente en rojo y en dos mensajes quedó claro quién manejaba los tiempos.',
    author: 'M. G.',
    age: '41 años',
    role: 'Contador',
    location: 'Rosario'
  }, {
    quote: 'El Onboarding Turbo cambió todo para mis clientes nuevos. Antes el primer mes era un caos de idas y vueltas. Ahora les mando el kit de bienvenida y entran ordenados desde el primer día.',
    author: 'L. P.',
    age: '38 años',
    role: 'Contadora, atención independiente',
    location: 'GBA'
  }, {
    quote: 'Los scripts de WhatsApp me parecían exagerados hasta que los usé. El primer mes recuperé 3 horas que antes perdía en mensajes que no llegaban a ningún lado.',
    author: 'S. M.',
    age: '29 años',
    role: 'Contador',
    location: 'Córdoba'
  }, {
    quote: 'Tenía miedo de parecer agresiva con mis clientes al poner límites. La Guía de Reglas de Juego tiene un tono tan profesional que mis clientes lo recibieron muy bien. Ahora ellos me preguntan qué falta en vez de esperar que yo insista.',
    author: 'R. A.',
    age: '45 años',
    role: 'Contadora',
    location: 'Mendoza'
  }];
  return <section id="testimonios" className="py-14 bg-slate-50" data-id="element-196">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-197">
        <div className="text-center mb-10" data-id="element-198">
          <h2 className="text-2xl md:text-3xl font-black text-[#1e3a5f] mb-2" data-id="element-199">
            Lo que dicen los contadores que ya usan el Sistema PRO
          </h2>
          <div className="flex justify-center space-x-0.5" data-id="element-200">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 text-[#d4a017] fill-current" data-id="element-201" />)}
          </div>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 space-y-4" data-id="element-202">
          {testimonials.map((testimonial, index) => <div key={index} className="break-inside-avoid bg-white p-5 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-203">
              <QuoteIcon className="w-6 h-6 text-[#d4a017] opacity-20 mb-2" data-id="element-204" />
              <p className="text-gray-700 italic mb-4 text-sm leading-relaxed" data-id="element-205">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-gray-100 pt-3" data-id="element-206">
                <p className="font-bold text-gray-900 text-sm" data-id="element-207">
                  {testimonial.author}, {testimonial.age}
                </p>
                <p className="text-xs text-gray-500" data-id="element-208">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}